import { render } from "./milestoneComponent.vue?vue&type=template&id=c658658a"
import script from "./milestoneComponent.vue?vue&type=script&lang=js"
export * from "./milestoneComponent.vue?vue&type=script&lang=js"

import "./milestoneComponent.vue?vue&type=style&index=0&id=c658658a&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__